import { useAppSelector } from '~/redux/hooks';
import { selectSelectedMaterial } from '~/redux/slices/material';

/**
 * True when the selected material is a Laminate-Product-Only (LPO) offering,
 * implemented as `isInstalled === false`.
 * Read-only: safe to call from Header / any layout component (no dispatches).
 * Undefined material (pre-selection, hard refresh) is treated as installed.
 */
export const useIsLaminateProductOnlySelected = (): boolean => {
  const selectedMaterial = useAppSelector(selectSelectedMaterial);

  return selectedMaterial?.isInstalled === false;
};
